<script lang="ts">
  let props = $props()
  let { responses } = props

  console.log(responses)
</script>

<div class="p-4">
  <h1 class="text-2xl font-bold mb-4">Admin Dashboard</h1>

  <div class="bg-white shadow rounded-lg p-6">
    <h2 class="text-xl font-semibold mb-4">Responses</h2>

    {#if responses && responses.length > 0}
      <div class="px-4 sm:px-6 lg:px-8">
        <div class="mt-8 flow-root">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"
            >
              <div
                class="overflow-hidden shadow-sm ring-1 ring-black/5 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        >ID</th
                      >
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >Started At</th
                      >
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >Completed?</th
                      >
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >Score</th
                      >

                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >Name</th
                      >
                      <th
                        scope="col"
                        class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        >Email</th
                      >
                      <th scope="col" class="relative py-3.5 pr-4 pl-3 sm:pr-6">
                        <span class="sr-only">View</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    {#each responses as response}
                      <tr>
                        <td
                          class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6"
                          >{response.id}</td
                        >
                        <td
                          class="px-3 py-4 text-sm whitespace-nowrap text-gray-500"
                          >{response.started_at
                            ? new Date(response.started_at).toLocaleString()
                            : "Not started"}</td
                        >
                        <td
                          class="px-3 py-4 text-sm whitespace-nowrap text-gray-500"
                        >
                          {#if response.completed_at}
                            <span class="text-green-500">
                              (Completed at {new Date(
                                response.completed_at
                              ).toLocaleString()})
                            </span>
                          {:else}
                            <span class="text-red-500"> (Not completed)</span>
                          {/if}</td
                        >
                        <td
                          class="px-3 py-4 text-sm whitespace-nowrap text-gray-500"
                        >
                          {#if response.score}
                            <span class="font-medium"
                              >{response.score.total}%</span
                            >
                          {:else}
                            <span class="text-gray-400">No score</span>
                          {/if}
                        </td>
                        <td
                          class="px-3 py-4 text-sm whitespace-nowrap text-gray-500"
                          ><span class="font-medium"
                            >{response.name || "N/A"}</span
                          ></td
                        >
                        <td
                          class="px-3 py-4 text-sm whitespace-nowrap text-gray-500"
                          ><span class="font-medium">{response.email}</span></td
                        >
                        <td
                          class="relative py-4 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap sm:pr-6"
                        >
                          <a
                            href="/results/{response.access_key}"
                            class="text-indigo-600 hover:text-indigo-900"
                            >View Report</a
                          >
                        </td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    {:else}
      <p>No recent responses found.</p>
    {/if}
  </div>
</div>
